import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import InsightCard from './cards/InsightCard';

import { device } from '../../utils/styled-component-mixins';
import useMediaQuery from '../custom-hooks/useMediaQuery';
import ServerStylesConditionalWrapper from '../shared/ServerStylesConditionalWrapper';
import 'swiper/css';
import 'swiper/css/pagination';

const RelatedResourcesWrapper = styled.div`
  position: relative;

  .related-resource-card-row {
    justify-content: center;

    > .col-lg-3 {
      position: relative;
      z-index: 100;
    }
  }
  .background-wrapper {
    ${(props) => props.backgroundImage && `background-image: url("${props.backgroundImage}");`}
    padding-bottom: 10rem;
    padding-top: 2rem;

    @media ${device.desktop} {
      margin-bottom: 15.2rem;
      padding-top: 8.8rem;
    }
  }

  .angled-background {
    padding-bottom: 0;

    @media ${device.deviceOnly} {
      margin-bottom: 8.3rem;
    }

    &:after {
      @media ${device.mobileOnly} {
        clip-path: polygon(100% 70%, 100% 101%, 0% 101%, 0% 85%);
      }
    }
  }

  .related-resources-heading {
    font-size: 3rem;
    font-weight: 400;
    letter-spacing: -0.02rem;
    text-align: center;
    margin-bottom: 2rem;

    @media ${device.desktop} {
      font-size: 3.6rem;
      font-weight: 400;
      line-height: 4.8rem;
      margin-bottom: 0;
    }
  }

  .col-lg-3,
  .swiper-slide {
    > div {
      margin-bottom: 0;
      height: 100%;

      .insight-card-wrapper {
        height: 100%;
      }

      .insight-card {
        height: 100%;
        display: flex;
        flex-direction: column;

        .featured-card-content {
          flex: 1 1 auto;

          .animation-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
          }
        }
      }
    }
  }

  .mobile-slider-row {
    .swiper {
      width: 100%;
      padding-bottom: 12.8rem;
    }
  }

  .related-resources-cta {
    display: flex;
    justify-content: center;
    position: absolute;
    right: 0;
    bottom: -4rem;
    width: 100%;

    @media ${device.desktop} {
      justify-content: flex-end;
      bottom: -7.6rem;
    }
  }
`;

const RelatedResources = (props) => {
  const cardProps = {
    layout: 'standard',
    mediaSide: 'left'
  };

  const isDesktop = useMediaQuery(device.desktop);

  if (isDesktop) {
    return (
      <ServerStylesConditionalWrapper>
        <RelatedResourcesWrapper
          backgroundImage={props.relatedResourcesBackground}
          className="related-resources-section"
        >
          <div className="container">
            <h2 className="related-resources-heading">{props.relatedResourcesHeading}</h2>
          </div>
          <div className="background-wrapper angled-background">
            <div className="container-padding-md">
              <div className="row related-resource-card-row">
                {props.relatedResources.map((item) => (
                  <div className="col-lg-3" key={item.pageTitle}>
                    <InsightCard
                      key={item.pageTitle}
                      cardProps={cardProps}
                      item={{
                        thumbnail: item.image,
                        primaryCategory: item.tag,
                        pageTitle: item.pageTitle,
                        publishDate: item.publishDate,
                        description: item.description,
                        readMoreText: props.featuredInsightLinkText,
                        url: item.url,
                        externalUrl: item.externalUrl,
                        isExternal: item.isExternal
                      }}
                    ></InsightCard>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </RelatedResourcesWrapper>
      </ServerStylesConditionalWrapper>
    );
  }

  return (
    <ServerStylesConditionalWrapper>
      <RelatedResourcesWrapper
        className="card-slider"
        backgroundImage={props.relatedResourcesBackground}
      >
        <div className="container">
          <h2 className="related-resources-heading">{props.relatedResourcesHeading}</h2>
        </div>
        <div className="background-wrapper angled-background">
          <div className="mobile-slider-row">
            <Swiper
              pagination={{ clickable: false }}
              centeredSlides={true}
              slidesPerView="auto"
              spaceBetween={16}
              modules={[Pagination]}
              init={false}
            >
              {props.relatedResources.map((item) => (
                <SwiperSlide key={item.pageTitle}>
                  <InsightCard
                    cardProps={cardProps}
                    item={{
                      thumbnail: item.image,
                      primaryCategory: item.tag,
                      pageTitle: item.pageTitle,
                      publishDate: item.publishDate,
                      description: item.description,
                      readMoreText: props.featuredInsightLinkText,
                      url: item.url,
                      externalUrl: item.externalUrl
                    }}
                  ></InsightCard>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </RelatedResourcesWrapper>
    </ServerStylesConditionalWrapper>
  );
};

export default RelatedResources;
